import * as UserProfileActions from './UserProfileActions';
import UserProfileReducer from './UserProfileReducer'
export {UserProfileActions,UserProfileReducer};